import { SelectField, SelectFieldProps } from 'components/form'
import React from 'react'

export enum ModeloAtestadoEnum {
  EM_BRANCO = 'Em branco',
  LICENCA_MATERNIDADE = 'Licença maternidade',
  PADRAO = 'Padrão',
}

export type AtestadoSelectModel = {
  value: ModeloAtestadoEnum
}

export interface AtestadoSelectFieldProps
  extends Omit<SelectFieldProps<AtestadoSelectModel>, 'items' | 'itemToString'> {
  canAccessLicencaMaternidade: boolean
}

export function AtestadoSelectField(props: AtestadoSelectFieldProps) {
  const { canAccessLicencaMaternidade } = props

  const itemToString = (item: AtestadoSelectModel) => item?.value

  const renderItems = () => {
    if (!canAccessLicencaMaternidade) {
      return items.filter((e) => e.value !== ModeloAtestadoEnum.LICENCA_MATERNIDADE)
    }

    return items
  }

  return (
    <SelectField<AtestadoSelectModel>
      items={renderItems()}
      itemToString={itemToString}
      clearable={false}
      defaultValue={items[0] as any}
      {...props}
    />
  )
}

const items: AtestadoSelectModel[] = [
  { value: ModeloAtestadoEnum.EM_BRANCO },
  { value: ModeloAtestadoEnum.LICENCA_MATERNIDADE },
  { value: ModeloAtestadoEnum.PADRAO },
]
